"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyLabel = void 0;
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const token_icon_1 = require("@shared-modules/components/token-icon");
const number_1 = require("@utils/object/number");
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const CurrencyLabel = (props) => {
    const { tokenAddress, amount, showIcon = true, isNormalized = false, scale = 0.7 } = props;
    const token = (0, tokens_reducer_1.useTokenByAddress)(tokenAddress);
    return (react_1.default.createElement("div", { className: "c-currency-label" },
        showIcon && react_1.default.createElement(token_icon_1.TokenIcon, { symbol: token === null || token === void 0 ? void 0 : token.symbol, scale: scale }),
        (amount === null || amount === void 0 ? void 0 : amount.toString()) ? (0, number_1.formatAndNormalizeToken)(token, amount, isNormalized ? 0 : token === null || token === void 0 ? void 0 : token.decimals) : token === null || token === void 0 ? void 0 : token.symbol));
};
exports.CurrencyLabel = CurrencyLabel;
